import { useEffect } from 'react';
const CRM_ORIGIN = process.env.REACT_APP_CRM_ORIGIN || 'http://localhost:3030';
const DOC_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001/api/v1';

const CrmTokenReceiver = ({ onTokenReceived }) => {
  useEffect(() => {
    const isInIframe = window.parent !== window;
    console.log('[CrmTokenReceiver] isInIframe =', isInIframe);
    if (!isInIframe) return;

    async function exchangePortalEmail(email) {
      console.log('[CrmTokenReceiver] exchangePortalEmail called | email =', email);
      if (!email) {
        console.warn('[CrmTokenReceiver] No email provided, skipping');
        return;
      }
      const lastEmail = localStorage.getItem('_last_portal_email');
      if (lastEmail === email && localStorage.getItem('token')) {
        console.info('[CrmTokenReceiver] Email unchanged, skipping re-auth');
        return;
      }
      console.log('[CrmTokenReceiver] Calling /auth/iframe | email =', email);
      try {
        const res = await fetch(`${DOC_API_URL}/auth/iframe`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email }),
        });
        console.log('[CrmTokenReceiver] /auth/iframe response | status =', res.status);
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          console.warn('[CrmTokenReceiver] iframe auth failed:', err.detail || res.status);
          return;
        }
        const data = await res.json();
        const docToken = data.access_token;
        if (!docToken) {
          console.warn('[CrmTokenReceiver] No access_token in response:', data);
          return;
        }
        localStorage.setItem('token', docToken);
        localStorage.setItem('_last_portal_email', email);
        console.info('[CrmTokenReceiver] Authenticated via Portal Email → doc-flatform JWT issued');
        if (onTokenReceived) onTokenReceived(docToken);
      } catch (err) {
        console.error('[CrmTokenReceiver] Error calling /auth/iframe:', err.message);
      }
    }

    const params = new URLSearchParams(window.location.search);
    const urlEmail = params.get('email');
    const fontFamily = params.get('fontFamily') || localStorage.getItem('crm_fontFamily');
    const fontSize = params.get('fontSize') || localStorage.getItem('crm_fontSize');
    const isOpenSidebar = params.get('isOpenSidebar');

    console.log('[CrmTokenReceiver] URL params | email =', urlEmail, '| fontFamily =', fontFamily, '| fontSize =', fontSize, '| isOpenSidebar =', isOpenSidebar);

    if (fontFamily) {
      document.body.style.fontFamily = fontFamily;
      localStorage.setItem('crm_fontFamily', fontFamily);
    }
    if (fontSize) {
      document.body.style.fontSize = fontSize;
      localStorage.setItem('crm_fontSize', fontSize);
    }
    if (isOpenSidebar !== null) {
      localStorage.setItem('crm_isOpenSidebar', isOpenSidebar);
    }

    if (urlEmail) {
      console.log('[CrmTokenReceiver] Email found in URL, cleaning params and authenticating');
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('email');
      newUrl.searchParams.delete('fontFamily');
      newUrl.searchParams.delete('fontSize');
      newUrl.searchParams.delete('isOpenSidebar');
      window.history.replaceState(null, '', newUrl.toString());
      exchangePortalEmail(urlEmail);
    }

    const handleMessage = (event) => {
      console.log('[CrmTokenReceiver] postMessage received | origin =', event.origin, '| type =', event.data?.type);
      try {
        const portalOrigin = new URL(CRM_ORIGIN).origin;
        if (event.origin !== portalOrigin) {
          console.warn('[CrmTokenReceiver] Ignored message from unknown origin:', event.origin);
          return;
        }
      } catch (_) {
        return;
      }

      const { type, email, fontFamily, fontSize, isOpenSidebar } = event.data || {};

      if (type === 'SET_CRM_CONFIG' && email) {
        console.log('[CrmTokenReceiver] SET_CRM_CONFIG received | email =', email, '| fontFamily =', fontFamily, '| fontSize =', fontSize, '| isOpenSidebar =', isOpenSidebar);
        if (fontFamily) {
          document.body.style.fontFamily = fontFamily;
          localStorage.setItem('crm_fontFamily', fontFamily);
        }
        if (fontSize) {
          document.body.style.fontSize = fontSize;
          localStorage.setItem('crm_fontSize', fontSize);
        }
        if (isOpenSidebar !== undefined && isOpenSidebar !== null) {
          localStorage.setItem('crm_isOpenSidebar', String(isOpenSidebar));
        }
        exchangePortalEmail(email);
        return;
      }

      if (type === 'SET_CRM_EMAIL' && email) {
        console.log('[CrmTokenReceiver] SET_CRM_EMAIL (legacy) received | email =', email);
        exchangePortalEmail(email);
      }
    };

    window.addEventListener('message', handleMessage);

    try {
      const targetOrigin = new URL(CRM_ORIGIN).origin;
      console.log('[CrmTokenReceiver] Sending DOC_SEARCH_READY to Portal | origin =', targetOrigin);
      window.parent.postMessage({ type: 'DOC_SEARCH_READY' }, targetOrigin);
    } catch (_) {}

    return () => window.removeEventListener('message', handleMessage);
  }, [onTokenReceived]);

  useEffect(() => {
    const isInIframe = window.parent !== window;
    if (!isInIframe) return;

    const syncPath = () => {
      try {
        console.log('[CrmTokenReceiver] SYNC_PATH | path =', window.location.pathname);
        window.parent.postMessage(
          { type: 'SYNC_PATH', path: window.location.pathname },
          CRM_ORIGIN
        );
      } catch (_) {}
    };

    syncPath();
    window.addEventListener('popstate', syncPath);

    const origPush = window.history.pushState.bind(window.history);
    const origReplace = window.history.replaceState.bind(window.history);

    window.history.pushState = (...args) => { origPush(...args); syncPath(); };
    window.history.replaceState = (...args) => { origReplace(...args); };

    return () => {
      window.removeEventListener('popstate', syncPath);
      window.history.pushState = origPush;
      window.history.replaceState = origReplace;
    };
  }, []);

  return null;
};

export default CrmTokenReceiver;
